import {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";

import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [error, setError] = useState("");

  const refreshUser = useCallback(async () => {
    const token = localStorage.getItem("jsm_token");

    if (!token) {
      setUser(false);
      return null;
    }

    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      localStorage.removeItem("jsm_token");
      setUser(false);
      return null;
    }
  }, []);

  useEffect(() => {
    refreshUser();
  }, [refreshUser]);

  const login = useCallback(
    async (username, password, role = "admin") => {
      setError("");

      try {
        const { data } = await api.post("/auth/login", {
          username,
          password,
          role,
        });

        localStorage.setItem("jsm_token", data.token);
        setUser(data.user);

        return data.user;
      } catch (e) {
        setError(formatApiError(e));
        return null;
      }
    },
    []
  );

  const logout = useCallback(() => {
    localStorage.removeItem("jsm_token");
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
        error,
        refreshUser,
        isLoading: user === null,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);